var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFffYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,24.6c3.2-1.6,6.3-3.2,9.6-4.9c-3.2-1.7-6.4-3.3-9.6-4.9C16,18.1,16,21.3,16,24.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -122.976,
    y1: 20,
    x2: 65.2773,
    y2: 20,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C47DD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDBCD4"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.8,15.9c-0.1-1-0.2-2-0.4-3C34,11.3,32.7,10.2,31,10c-2.3-0.2-4.5-0.3-6.8-0.3c-2.7,0-5.4-0.1-8.1,0 c-2,0-4,0.2-6,0.3c-0.6,0-1.2,0.1-1.7,0.2c-1.4,0.3-2.3,1.1-2.8,2.4c-0.4,1-0.5,2-0.5,3c0,0.6-0.1,1.2-0.1,1.8c0,0.1,0,0.2,0,0.2 c0,1.6,0,3.2,0,4.8c0,0.5,0,0.9,0.1,1.4c0.1,1,0.2,2.1,0.4,3.1C5.8,28.6,7.2,29.8,9,30c2.3,0.2,4.5,0.3,6.8,0.3 c2.7,0,5.4,0.1,8.1,0c2.1,0,4.2-0.2,6.2-0.3c0.5,0,1-0.1,1.5-0.2c1.4-0.3,2.3-1.1,2.8-2.4c0.4-1,0.4-2,0.5-3 c0.1-0.6,0.1-1.2,0.1-1.8c0-0.1,0-0.2,0-0.3c0-1.6,0-3.2,0-4.9C34.8,17,34.8,16.4,34.8,15.9z M16,24.6c0-3.3,0-6.5,0-9.8 c3.2,1.6,6.3,3.3,9.6,4.9C22.3,21.3,19.1,22.9,16,24.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFffYoutube);
export default __webpack_public_path__ + "static/media/fff-youtube.15b351dd6b0c6ab9bd8124ba7a66a9d5.svg";
export { ForwardRef as ReactComponent };